import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import PortFolioItem from "./PortFolioItem";
import LayoutContainer from "../../components/LayoutsContainer";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // height: "300px",
    [theme.breakpoints.down("md")]: {
      //   backgroundColor: "red",
    },
  },
}));

const PortFolioCarousel = ({ data }) => {
  const classes = useStyles();
  const SliderItems = data?.map((item, index) => {
    return <PortFolioItem data={item} key={index} />;
  });

  return (
    <div className={classes.root}>
      <AliceCarousel
        autoPlay
        disableButtonsControls
        disableDotsControls
        infinite
        autoPlayInterval={5000}
        mouseTracking
        items={SliderItems}
        responsive={{
          0: {
            items: 3,
          },

          600: {
            items: 4,
            autoPlayInterval: 5000,
          },
          200: {
            items: 3,
            autoPlayInterval: 5000,
          },
          960: {
            items: 4,
            autoPlayInterval: 5000,
          },
          1280: {
            items: 4,
            autoPlayInterval: 5000,
          },
        }}
      />
    </div>
  );
};
export default PortFolioCarousel;
